import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';
import { PrintJson } from '../../../theme/Component/PrintJson';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectStateConst = ({ idSelector, onChange, label }: Props) => {

    const service = new FinanceService();
    const [id, setID] = useState<any>("");
    const [listaType, setListaType] = useState([]);
    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        getListaType();
    }, [])

    const setValue = (e: any) => {
        if (e === "") {
            onChange(null);
            setID("");
        } else {
            setID(parseInt(e));
            onChange(e);
        }
    }

    // const getLista = () => {
    //     macroProcess.instance.getMacroProcessCatalog().then(
    //         (resp) => {
    //             setLista(resp)
    //             if (resp.length > 0 && !idSelector) {
    //                 setID(resp[0].DataBeanProperties.IDMacroProcess)
    //             }
    //         }
    //     )
    // }

    const getListaType = () => {
        service.getPaymentAccountOperationStateConstants(null).subscribe((resp: any) => {
            if (resp.DataBeanProperties.ObjectValue) {
                setListaType(resp.DataBeanProperties.ObjectValue);
            }
        });
    };

    return (
        <>
            <label>{label ?? ":"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {listaType.length > 0 &&
                    listaType.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}